export default "__VITE_ASSET__CAhsvabH__"